import { useContext, useEffect, useState } from 'react'

import { toNumber } from 'lodash'

import { EndUser } from '@driftt/api-types'
import { getDriftWebSocket, initializeWebSocket } from '@driftt/drift-ws'
import { GlobalStore } from '@driftt/traffic-control'

import { PresenceContext } from 'context/presenceContext'
import { ActivityEndUser } from 'modules/accountActivity/domain'

const END_USER_TYPE = 2
const LEAD_USER_TYPE = 4

const usePresenceSubscription = (orgId: number, endUsers: ActivityEndUser[] | EndUser[]): Set<number> => {
  const [socketSetupComplete, setSocketSetupComplete] = useState<boolean>(false)
  const { presentEndUserIds, setEndUserPresent } = useContext(PresenceContext)

  const socket = GlobalStore.getState().socket

  useEffect(() => {
    if (orgId && socket) {
      initializeWebSocket(orgId, GlobalStore)
      setSocketSetupComplete(true)
    }
  }, [orgId, socket])

  useEffect(() => {
    if (socketSetupComplete) {
      const ws = getDriftWebSocket()
      const subs = [...endUsers].map(endUser => {
        const newPresenceSub = ws
          .on<any>({
            cluster: 'chat',
            channelName: `user_presence:${orgId}-${endUser.id}-${
              endUser.type === 'END_USER' ? END_USER_TYPE : LEAD_USER_TYPE
            }`,
            messageName: 'presence:update'
          })
          .subscribe(() => {
            setEndUserPresent(toNumber(endUser.id))
          })
        return newPresenceSub
      })
      return () => {
        subs.forEach(sub => sub.unsubscribe())
      }
    }
  }, [socketSetupComplete, orgId, endUsers, setEndUserPresent])

  return presentEndUserIds
}

export default usePresenceSubscription
